import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConsentAcceptanceRequest, ConsentControllerService, EventInfoWithConsentResponse } from '@ent-regis/entregis-ts-angular';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';
import { EventService } from 'src/app/shared/services/event.service';

@Component({
  selector: 'app-investor-consent',
  templateUrl: './investor-consent.component.html',
  styleUrls: ['./investor-consent.component.scss']
})
export class InvestorConsentComponent implements OnInit, OnDestroy {

  private subscription: Subscription;
  public eventInfo: EventInfoWithConsentResponse;

  constructor(
    private eventService: EventService,
    private consentService: ConsentControllerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
  ) { }

  ngOnInit() {
    this.subscription = new Subscription();

    this.subscription.add(this.eventService.eventSubject.subscribe(x => {
      this.eventInfo = x;
    }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private getRegisterInvestorId(): string | null {
    let route = this.activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.paramMap.get('registerInvestorId');
  }

  acceptConsent(data: ConsentAcceptanceRequest[]) {
    this.consentService.acceptConsentUsingPOST(data).subscribe(x => {
      this.router.navigate(['regis', this.eventInfo.eventAlias, this.authService.loginType, this.getRegisterInvestorId()]);
    });
  }

}
